/* eslint-disable no-console */
import { PRODUCT_ID } from '@/config/auth.config';
import { getURLParams } from '@/utils/URLParams.utils';
import { LocationUtils } from './location.utils';
import { EnvUtils } from '../env.utils';

export async function getSubscriptionId() {
  if (EnvUtils.isDevelopment()) {
    return getURLParams(window.location.href)?.subscriptionid;
  }

  const url = await LocationUtils.getWorkspaceUrl();

  try {
    const pathnameParamsArray = url.pathname.split('/');
    const productIdIndex = pathnameParamsArray.findIndex((el) => el === PRODUCT_ID);

    if (productIdIndex === -1) {
      // throw new Error('An error occurred while retrieving the subscription id');
      return null;
    }

    const subscriptionId = pathnameParamsArray[productIdIndex + 1];
    return subscriptionId;
  } catch (err: any) {
    // appInsights.trackException({ error: new Error(err?.message) }, {
    //   exceptionType: ExceptionTypes.AUTH_EXCEPTION,
    //   pageUrl: window.location.href,
    // });
    console.error(err);
    return;
    // return errorNotificationCallback(err?.message);
  }
}


